export const USER_MANAGEMENT_ENDPOINTS = {
  LIST: "/user-management/user-list",
  CREATE: "/user-management/user",
  DETAIL: (userId) => `/user-management/user/${userId}`,
  UPDATE: (userId) => `/user-management/user/${userId}`,
  FOLLOW_UP: (userId) => `/user-management/follow-up/${userId}`,
  UNFOLLOW_UP: (userId) => `/user-management/unfollow-up/${userId}`,
  CHECK_CAN_CREATE: "/user-management/checkCanCreateUser",
};
